module.exports = __webpack_public_path__ + "img/fishing-mweya.b6fe182f.webp";